module.exports = __webpack_public_path__ + "img/icons B_13.5e561103.svg";